import React from 'react'
import PropTypes from 'prop-types'

// import css from './styles.js'
import { _Line } from './styles'

const SectionSeparatorLine = ({ className, globalClassName }) => (
  <_Line className={`${className} ${globalClassName || ''}`} />
)


SectionSeparatorLine.propTypes = {
  className: PropTypes.string,
  globalClassName: PropTypes.string,
}

export default SectionSeparatorLine

